import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

// Strategies the live auto-trade executor supports.
export default function StopLossStrategySelect({
  exitStrategy,
  onChange,
}: {
  exitStrategy: string
  onChange: (key: string, value: any) => void
}) {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="stop-loss-strategy-label">Stop Loss Strategy</InputLabel>
      <Select
        labelId="stop-loss-strategy-label"
        value={exitStrategy}
        name="generateTrades.exitStrategy"
        onChange={(e) => {
          // Fixed entries are price distances, the others R:R ratios; neither carries over.
          if ((exitStrategy === 'fixed') !== (e.target.value === 'fixed')) {
            onChange('generateTrades.tradeRatios', [])
          }
          onChange(e.target.name, e.target.value)
        }}
        label="Stop Loss Strategy"
      >
        <MenuItem value="atr">ATR</MenuItem>
        {/* Incremental is a backtesting sweep (one trade per stop-loss
            step) and has never been implemented by the live auto-trade
            executor, which silently skips it (gc-core#340). It stays
            available for backtests; here it is only rendered -- disabled
            -- when a legacy plan already carries it, so the Select shows
            the truth and nudges the user onto a supported strategy. */}
        {exitStrategy === 'incremental' && (
          <MenuItem value="incremental" disabled>
            Incremental (not supported for Auto Trade)
          </MenuItem>
        )}
        <MenuItem value="fixed">Fixed</MenuItem>
        <MenuItem value="peak_valley">Fractal</MenuItem>
        <MenuItem value="high_low">High/Low</MenuItem>
      </Select>
    </FormControl>
  )
}
